import React, { Suspense, lazy } from 'react';

import {
  BrowserRouter as Router,
  Switch,
  Route,
  withRouter,
  Redirect
} from 'react-router-dom';

import ScrollToTop from './components/RouteWithLayout/ScrollToTop';
import ProtectedRoute from 'common/Utils/ProtectedRoute';
import Master from './components/Master';

const paths = {
  index: '/Home',
  pagamento: '/pagamento',
  autorizacaoPesquisa: '/VisualizarRequerimento',

  indicadores: '/indicadores',
  consultarCamadasInterseccionadas: '/ConsultarCamadasInterseccionadas',
  relatorioRequerimento: '/Relatorios/Requerimento',
  relatorioEmolumento: '/Relatorios/Emolumento',
  relatorioResponsavelTecnico: '/Relatorios/ResponsavelTecnico',
  relatorioPlanoPesquisa: '/Relatorios/PlanoPesquisa',
  relatorioAtividadePlanoPesquisa: '/Relatorios/AtividadePlanoPesquisa',
  hangfire: '/HangFire',
  hangfireFailed: '/HangFire/Failed',
  hangfireProcessing: '/HangFire/Processing',
  hangfireEnqueued: '/HangFire/Enqueued',
  hangfireScheduled: '/HangFire/Scheduled',
  hangfireSucceeded: '/HangFire/Succeeded',
  hangfireServers: '/HangFire/Servers',
  relatorioRequerimentoLote: '/Relatorios/RequerimentoLote',
  gerarFolhaRosto: '/Relatorios/GerarFolhaRosto',
  assinatura: '/Assinatura',
  acesso: '/acesso',
  indisponibilidade: '/Indisponibilidade',
  signinCallback: '/signin-callback',
  logoutCallback: '/logout-callback',
  loginRedirect:"/login-redirect"
};

const Index = withRouter(lazy(() => import('./pages/Home')));
const Stepper = withRouter(lazy(() => import('./pages/Stepper')));
const AutorizaoPesquisa = withRouter(
  lazy(() => import('./pages/AutorizacaoPesquisa'))
);
const Indicadores = withRouter(lazy(() => import('./pages/Indicadores')));
const ConsultarCamadasInterseccionadas = withRouter(lazy(() => import('./pages/ConsultarCamadasInterseccionadas')));
const RelatorioRequerimento = withRouter(lazy(() => import('./pages/Relatorios/Requerimento')));
const RelatorioEmolumento = withRouter(lazy(() => import('./pages/Relatorios/Emolumento')));
const RelatorioResponsavelTecnico = withRouter(lazy(() => import('./pages/Relatorios/ResponsavelTecnico')));
const RelatorioPlanoPesquisa = withRouter(lazy(() => import('./pages/Relatorios/PlanoPesquisa')));
const RelatorioAtividadePlanoPesquisa = withRouter(lazy(() => import('./pages/Relatorios/AtividadePlanoPesquisa')));
const RelatorioRequerimentoLote = withRouter(lazy(() => import('./pages/Relatorios/RequerimentoLote')));
const GerarFolhaRosto = withRouter(lazy(() => import('./pages/Relatorios/GerarFolhaRosto')));

const HangFire = withRouter(lazy(() => import('./pages/HangFire')));
const HangFireFailed = withRouter(lazy(() => import('./pages/HangFire/Failed')));
const HangFireProcessing = withRouter(lazy(() => import('./pages/HangFire/Processing')));
const HangFireEnqueued = withRouter(lazy(() => import('./pages/HangFire/Enqueued')));
const HangFireScheduled = withRouter(lazy(() => import('./pages/HangFire/Scheduled')));
const HangFireSucceeded = withRouter(lazy(() => import('./pages/HangFire/Succeeded')));
const HangFireServers = withRouter(lazy(() => import('./pages/HangFire/Servers')));

const Acesso = withRouter(lazy(() => import('./pages/Acesso')));
const Indisponibilidade = withRouter(lazy(()=>import('./pages/Indisponibilidade')));
const Assinatura = withRouter(lazy(()=>import('./pages/Assinatura')));
const SigninCallback = withRouter(lazy(() => import('./pages/auth/signinCallback')));
const LogoutCallback = withRouter(lazy(() => import('./pages/auth/logoutCallback')));
const LoginRedirect = withRouter(lazy(() => import('./pages/auth/loginRedirect')));

const Routes = () => {
  return (
    <Router>
      <Suspense fallback={<div />}>
        <ScrollToTop />
        <Master>
          <Switch>
            <Route component={SigninCallback} exact path={paths.signinCallback} />
            <Route component={LogoutCallback} exact path={paths.logoutCallback} />
            <Route component={LoginRedirect} exact path={paths.loginRedirect} />
            <Route component={Acesso} exact path={paths.acesso} />
            <Route component={Indisponibilidade} exact path={paths.indisponibilidade} />
            <ProtectedRoute component={Index} exact path={paths.index}/>
            <ProtectedRoute component={Stepper} exact path={paths.pagamento} />
            <ProtectedRoute
              component={AutorizaoPesquisa}
              exact
              path={paths.autorizacaoPesquisa}
            />
            <ProtectedRoute component={Assinatura} exact path={paths.assinatura}/>
            <ProtectedRoute component={Indicadores} exact path={paths.indicadores} />
            <ProtectedRoute component={ConsultarCamadasInterseccionadas} exact path={paths.consultarCamadasInterseccionadas} />
            <ProtectedRoute component={RelatorioRequerimento} exact path={paths.relatorioRequerimento} />
            <ProtectedRoute component={RelatorioEmolumento} exact path={paths.relatorioEmolumento} />
            <ProtectedRoute component={RelatorioResponsavelTecnico} exact path={paths.relatorioResponsavelTecnico} />
            <ProtectedRoute component={RelatorioPlanoPesquisa} exact path={paths.relatorioPlanoPesquisa} />
            <ProtectedRoute component={RelatorioAtividadePlanoPesquisa} exact path={paths.relatorioAtividadePlanoPesquisa} />
            <ProtectedRoute component={HangFire} exact path={paths.hangfire} />
            <ProtectedRoute component={HangFireFailed} exact path={paths.hangfireFailed} />
            <ProtectedRoute component={HangFireProcessing} exact path={paths.hangfireProcessing} />
            <ProtectedRoute component={HangFireEnqueued} exact path={paths.hangfireEnqueued} />
            <ProtectedRoute component={HangFireScheduled} exact path={paths.hangfireScheduled} />
            <ProtectedRoute component={HangFireSucceeded} exact path={paths.hangfireSucceeded} />
            <ProtectedRoute component={HangFireServers} exact path={paths.hangfireServers} />
            <ProtectedRoute component={RelatorioRequerimentoLote} exact path={paths.relatorioRequerimentoLote} />
            <ProtectedRoute component={GerarFolhaRosto} exact path={paths.gerarFolhaRosto} />
            <Redirect exact from="/" to={paths.index} />
            <Redirect to="/" />
          </Switch>
        </Master>
      </Suspense>
    </Router>
  );
};

export { Routes, paths };
